/////////////////////////////////////////////////////////////////////////
// DebugUtils //////////////////////////////////////////////////////////
/////////////////////////////////////////////////////////////////////////
const DebugUtils = {

  forcePortrait: false,

  init: function(game, config) {

    this.game = game;
    this.config = config;

  },

  create: function() {

    // Separate this from init in case game is not ready for display elements, etc.

    // fps view
    if (this.config.showFPS) {

      this.fpsView = this._createFpsView();

    }
    

    // quick rotate keys
    if (this.config.enableQuickRotate) {

      this._createQuickRotateHotkeys();

    }

  },

  _createFpsView: function() {
        
    this.game.time.advancedTiming = true;

    var fpsStyle = { font: '32px Arial', fill: '#ffffff', align: 'left' };
    var fps = this.game.add.group();
    var fpsBack = this.game.add.graphics(0, 0, fps);
    fpsBack.beginFill(0);
    fpsBack.drawRect(0, 0, 200, 30);
    fpsBack.endFill();
    
    var fpsText = this.game.add.text(0, 1, '000', fpsStyle, fps); 
    
    fps.backing = fpsBack;
    fps.frameRate = fpsText;
    fps.updateTime = 0;
    fps.render = function() {
    
      this.frameRate.text = this.game.time.fps.toString()+', '+this.updateTime.toString();  

    };

    return fps;

  },

  // quick rotate
  _createQuickRotateHotkeys: function() {

    this.game.input.enabled = true;

    this.game.input.keyboard.addKey(Phaser.Keyboard.ONE).onDown.add(this._quickRotateP, this);
    this.game.input.keyboard.addKey(Phaser.Keyboard.TWO).onDown.add(this._quickRotateL, this);

  },

  _quickRotateP: function(key) {

    this.forcePortrait = true;
    
    this.game.scale.setGameSize(this.config.minWidthPortrait, this.config.minHeightPortrait); 

  },

  _quickRotateL: function(key) {

    this.forcePortrait = false;
    
    this.game.utils.sizeManager.resizeGame();
    

  }

};

export default DebugUtils;









// WEBPACK FOOTER //
// ./app/src/utils/debug/DebugUtils.js